<template>
    <div v-loading="loading" class="max-width">
        <!-- <el-row>
            <h3>公共水質</h3>
            <div v-for="(item, index) in monitorData" :key="index">
                <el-col :span="4">
                    <el-tooltip class="item" effect="dark" :content="item.address" placement="top">
                        <el-result  icon="success" :title="item.address.slice(0, 12)" subTitle="" 
                        @click.native="showMonitorData(item)" />
                    </el-tooltip>
                </el-col>
            </div>
        </el-row> -->
        <!-- <el-row>
            <h3>公共用水</h3>
            <div v-for="(item, index) in faucetData.filter( d => 'usage' in d && d.usage === 'public' )" :key="index">
                <el-col :span="4">
                    <el-result  icon="success" >
                        <template slot="title">
                            <el-tooltip class="item" effect="dark" :content="item.address" placement="top" >
                                <p @click="showProfile({waterId: item.waterId , waterNum:  item.waterNum, meterNum: item.meterNum})">
                                    {{ "alias" in item? item.alias : item.address.slice(0, 12)}}
                                </p>
                            </el-tooltip>
                        </template>
                        <template slot="subTitle">
                            <el-popover placement="top" width="20" trigger="click">
                                <el-input placeholder="更新用戶別名" v-model="alias_name" maxlength="12" show-word-limit />
                                <div style="text-align: right; margin-top: 5px;">
                                    <el-button type="success" size="mini" @click="editAlias(item.waterId)">更新</el-button>
                                </div>
                                <el-button slot="reference" type="primary" size="mini">編輯用戶別名</el-button>
                            </el-popover>
                        </template>
                    </el-result>
                </el-col>
            </div>
        </el-row> -->
        <!-- <el-row>
            <h3>住戶用水</h3>
            <div v-for="(item, index) in faucetData.filter( d => ! 'usage' in d || d.usage !== 'public' )" :key="index">
                <el-col :span="4">
                    <el-result  icon="success" >
                        <template slot="title">
                            <el-tooltip class="item" effect="dark" :content="item.address" placement="top" >
                                <p @click="showProfile({waterId: item.waterId , waterNum:  item.waterNum, meterNum: item.meterNum})">
                                    {{ "alias" in item? item.alias : item.address.slice(0, 12)}}
                                </p>
                            </el-tooltip>
                        </template>
                        <template slot="subTitle">
                            <el-popover placement="top" width="20" trigger="click">
                                <el-input placeholder="更新用戶別名" v-model="alias_name" maxlength="12" show-word-limit />
                                <div style="text-align: right; margin-top: 5px;">
                                    <el-button type="success" size="mini" @click="editAlias(item.waterId)">更新</el-button>
                                </div>
                                <el-button slot="reference" type="primary" size="mini">編輯用戶別名</el-button>
                            </el-popover>
                        </template>
                    </el-result>
                </el-col>
            </div>
        </el-row> -->
        
        
        <div class="singlePage-row">
            <div class="singlePage-title">{{titleName}}</div>
            <div class="chart-tag">
                <div class="tag-item">
                    <div class="tag-icon tag-color-1"></div>
                    <p>正常</p>
                </div>
                <div class="tag-item">
                    <div class="tag-icon tag-color-2"></div>
                    <p>斷訊</p>
                </div>
                <div class="tag-item">
                    <div class="tag-icon tag-color-3"></div>
                    <p>疑似漏水</p>
                </div>
                <div class="tag-item">
                    <div class="tag-icon tag-color-4"></div>
                    <p>水質異常</p>
                </div>
            </div>
        </div>

        <el-card class="box-card water-block">
            <el-row :gutter="5">
                <div v-for="(item, index) in faucetData" :key="index">
                    <el-col :span="8" :xs="24">
                        <el-popover placement="top" width="260" trigger="click" class="user-item">
                            <el-input type="text" placeholder="更新用戶別名" v-model="alias_name" maxlength="50" show-word-limit></el-input>
                            <div class="user-item-btn">
                                <el-button type="success" size="small" @click="editAlias(item.waterId)">更新</el-button>
                            </div>
                            <el-button slot="reference" type="text" icon="el-icon-edit-outline">
                                <div class="tag-icon tag-color-1"></div>
                                <p>
                                    <el-tooltip class="item" effect="dark" :content="item.address" placement="top">
                                        <a @click="showProfile({waterId: item.waterId , waterNum:  item.waterNum, meterNum: item.meterNum})" class="faucetData-text"> 
                                            {{ "alias" in item? item.alias : item.address }}
                                        </a>
                                    </el-tooltip>
                                </p>
                            </el-button>
                        </el-popover>
                    </el-col>
                </div>
            </el-row>
        </el-card>


        <el-dialog :title="dialogData.item.address" :visible.sync="dialogData.show" width="60%"  center :close-on-click-modal="false">            
            <div style="width:100%; height:400px">
                <v-chart :option="dialogData.ntuChart" :loading="loading" style="width:100%;height:100%" autoresize />
            </div>
            <div style="width:100%; height:400px">
                <v-chart :option="dialogData.ppmChart" style="width:100%;height:100%" autoresize />
            </div>
            <div style="width:100%; height:400px">
                <v-chart :option="dialogData.phChart" style="width:100%;height:100%" autoresize />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogData.show = false" size="small">返回</el-button>
            </div>
        </el-dialog>
        <FanReplacementStatus :show="frsDialog.show" :data="frsDialog.data" @close="frsDialogOnClose()"></FanReplacementStatus>
    </div>
</template>

<script>
import _ from 'lodash'
import FanReplacementStatus from '@/views/FanReplacementStatus'

export default {
    // 用戶清單
    name: 'ProfileGroupList',
    components: {
        FanReplacementStatus,
    },
    data()
    {
        return  {
            titleName: '',
            loading: false,
            visible: false,
            alias_name: '',
            faucetData: [],
            monitorData: [],
            waterList: [],
            frsDialog: {
                show: false,
                data: [],
            },
            dialogData: {
                show: false,
                data: {},
                item: {},
                ntuChart: {
                    title: {
                        text: "濁度",
                    }, 
                    series:
                    [
                        {
                        type: 'gauge',
                        data: [
                            {
                                value: 50,
                                name: 'NTU'
                            }
                        ]
                        },
                    ]
                },
                ppmChart: {
                    title: {
                        text: "餘氯",
                    }, 
                    series:
                    [
                        {
                        type: 'gauge',
                        data: [
                            {
                                value: 50,
                                name: 'ppm'
                            }
                        ]
                        },
                    ]
                },
                phChart: {
                    title: {
                        text: "酸鹼度",
                    }, 
                    series:
                    [
                        {
                        type: 'gauge',
                        data: [
                            {
                                value: 50,
                                name: 'pH'
                            }
                        ]
                        },
                    ]
                },
            },
        }
    },
    async created()
    {
        this.titleName = localStorage.getItem('name')
    },
    async mounted()
    {
        try{
            this.loading = true
            await this.getData()
            await this.getFanReplacementStatus()
        }catch(ex){
            console.log('API Error')
        }finally{
            this.loading = false
        }
    },
    methods:
    {
        async getData()
        {
            let url = "/api/system/monitor"
            // this.loading = true
            await this.axios.get(url).then( res =>
            {
                // console.log(res.data)
                if(_.isArray(res.data.content))
                {
                    this.monitorData = res.data.content
                }
                else
                {
                    this.$message({ message: '無法擷取資料!', type: 'warning' }) 
                }
            })
            .catch( () =>
            {
                this.$message({ message: '無法擷取資料!', type: 'warning' })
            })
            .finally( () =>
            {
                // this.loading = false
            })

            url = "/api/system/profile?size=9999"
            // this.loading = true
            await this.axios.get(url).then( async res =>
            {
                // console.log(res.data)
                if(_.isArray(res.data.content))
                {
                    let waterIds = "/api/system/citizenAlias?waterIds="
                    this.faucetData = res.data.content
                    _.forEach(this.faucetData, e => 
                    {
                        waterIds += e.waterId + ","
                        
                        // 儲存Water資訊已供維護公告使用
                        this.waterList.push({
                            waterId:e.waterId,
                            waterNum:e.waterNum,
                            activated:e.activated
                        })
                    })
                    // 取得用戶別名
                    await this.axios.get(waterIds).then( res => 
                    {
                        _.forEach( _.keys(res.data), e => 
                        {
                            _.find(this.faucetData, {waterId: e})["alias"] = res.data[e]
                        })
                    })
                }
                else
                {
                    this.$message({ message: '無法擷取資料!', type: 'warning' }) 
                }
            })
            .catch( () =>
            {
                this.$message({ message: '無法擷取資料!', type: 'warning' })
            })
            .finally( () =>
            {
                // this.loading = false
            })
        },
        showMonitorData(item)
        {
            let url = "/api/report/monitor/" + item.id + "/rawdata"
            this.loading = true
            this.dialogData.item = {}
            this.axios.get(url).then( res =>
            {
                if( _.has(res.data, 'exception'))
                {
                    throw res.data.message
                }
                else
                {
                    this.dialogData.item = item
                    this.dialogData.ntuChart.series[0].data[0].value = res.data.data.cntu
                    this.dialogData.ppmChart.series[0].data[0].value = res.data.data.cl
                    this.dialogData.phChart.series[0].data[0].value = res.data.data.ph
                    this.dialogData.show = true
                }
            })
            .catch( () =>
            {
                this.$message({ message: '無法擷取資料!', type: 'warning' })
            })
            .finally( () =>
            {
                this.loading = false
            })
        },
        showProfile(c)
        {
            let currentProfile =
            {
                waterId: c.waterId,
                waterNum: c.waterNum,
                meterNum: c.meterNum,
            }
            localStorage.setItem('currentProfile', JSON.stringify(currentProfile)) // 將 currentProfile 存至 localStorage (物件要先字串化)
            // this.$store.commit('SET_CURRENT_WATERID', currentProfile) // 設定 當前查看的用水編號
            this.$router.push({ name: '用水狀況' })
        },
        editAlias(waterId)
        {
            let url = "/api/system/update/citizenAlias?waterIds=" + waterId + "&citizenAlias=" + this.alias_name
            this.loading = true
            this.axios.get(url).then( res =>
            {
                if(_.has(res.data, "code") && res.data.code === 200)
                {
                    this.$message({ message: '更新別名成功!', type: 'success' })
                    this.visible = false
                    this.alias_name = ''
                }
                else
                {
                   throw true
                }
            })
            .catch( () =>
            {
                this.$message({ message: '更新別名失敗!', type: 'warning' })
            })
            .finally( async () =>
            {
                await this.getData()
                this.loading = false
            })
        },
        async getFanReplacementStatus() {

            const runningStatusWaterList = []

            const promiseList = this.waterList.map(async (e) => 
                {
                    const _waterId = e.waterId
                    const _waterNum = e.waterNum
                    const _activated = e.activated
                    const resp = await this.axios.get('/api/material/fan/replacement/status/' + _waterId)
                    
                    return {
                        waterId: _waterId,
                        waterNum: _waterNum,
                        activated:_activated,
                        status: resp.data
                    }
                }
            )
            await Promise.all(promiseList).then((res) => {
                res.map(r => {
                    if (r.status == 'Running' || !r.activated) {
                        runningStatusWaterList.push({
                            waterId: r.waterId,
                            waterNum: r.waterNum,
                            status: r.status,
                            activated: r.activated
                        })
                    }
                })
            })

            if(_.isArray(runningStatusWaterList) && runningStatusWaterList.length > 0) {
                this.frsDialog.show = true
                this.frsDialog.data = runningStatusWaterList
            }
        },
        // 傳輸設備維護公告關閉時觸發
        frsDialogOnClose() {
            this.frsDialog.show = false
            this.frsDialog.data = []
        }
    }
}
</script>

<style >
.el-result__icon svg {
    width: 32px;
    height: 32px;
}

.faucetData-text{
    /* font-size: 16px; */
    cursor: pointer;
}

a {
    color: #5d9cec;
}
</style>